import ColumnSet from '@/components/grid/columns/column-set';
import ColumnsDefinition from '@/common/definitions/columns/webhooks';

export default function createColumns(testWebhook) {
    return new ColumnSet({
        id: 'webhook-list',
        ...ColumnsDefinition(testWebhook),
    });
}
